import React, {useEffect, useState} from "react";
import styled from "styled-components";
import {useDispatch, useSelector} from "react-redux";
import {loadAllTagCategories} from "../tag/tagCategory/tagCategoryAction";
import {v4 as uuidv4} from "uuid";
import {useLocation} from "react-router-dom";
import {removeDuplicatesInArray} from "../../utils/utils";

const SearchBarByTag = ({setData, data}) => {

    const dispatch = useDispatch()
    const {status: projectsStatus} = useSelector(state => state.projects)
    const {status: okrsStatus} = useSelector(state => state.objectives)
    const {isLoading, tagCategories} = useSelector(state => state.tagCategories)
    const {pathname} = useLocation()

    const [categorySelected, setCategorySelected] = useState({})
    const [tagSelected, setTagSelected] = useState({})
    const [states, setStates] = useState({})

    useEffect(() => {
        let data = {}
        if (tagCategories) {
            tagCategories.forEach((c) => {
                data[c.id] = false
            })
        }
        for (let key in data) {
            if (Number(key) === categorySelected.id) {
                data[key] = true
            }
        }

        setStates(data)
    }, [categorySelected, tagCategories])

    const filterBySubTag = (tag) => {
        setTagSelected(tag)
    }

    const filterByCategory = (category) => {
        setTagSelected({})
        if (categorySelected.id !== category.id) {
            setCategorySelected(category)
        }
        let newState = {}
        for (let key in states) {
            newState[key] = false
        }
        setStates({...newState, [category.id]: true})
    }

    useEffect(() => {
        let tagsIsChosen = tagSelected.id && categorySelected
        let categoryIsChosen = categorySelected && !tagSelected.id
        if (tagsIsChosen) {
            let itemsSelected = []
            setCategorySelected(categorySelected)
            setTagSelected(tagSelected)
            data.forEach((d) => {
                d.tags.forEach((tag) => {
                    if (tag.id === tagSelected.id) {
                        itemsSelected.push(d)
                    }
                })
            })
            itemsSelected = removeDuplicatesInArray(itemsSelected)
            setData(itemsSelected)
        }

        if (categoryIsChosen) {
            setTagSelected("")
            let itemsSelected = []
            setCategorySelected(categorySelected)
            data.forEach((d) => {
                d.tags.forEach((tag) => {
                    if (tag.category === categorySelected.name) {
                        itemsSelected.push(d)
                    }
                })
            })
            itemsSelected = removeDuplicatesInArray(itemsSelected)
            setData(itemsSelected)
        }
    }, [categorySelected, data, setData, tagSelected])


    useEffect(() => {
        dispatch(loadAllTagCategories())
    }, [dispatch, okrsStatus, pathname, projectsStatus])

    const displayTags = () => {
        if (tagCategories) {
            if (!isLoading && tagCategories.length > 0) {
                return (
                    <Ul>
                        {tagCategories.map(c => (
                                <li className={"wrapper-tags-li"} key={uuidv4()}>
                                    <div style={{
                                        backgroundColor: states[c.id] === true ? 'var(--color-purple-lighten)' : c.color,
                                        color: states[c.id] === true ? 'var(--color-purple-black)' : null
                                    }}
                                         className="category"
                                         onClick={() => filterByCategory(c)}>
                                        <p style={{color: states[c.id] === true ? 'var(--color-purple-black)' : 'var(--color-purple-white)'}}>
                                            {c.name}
                                        </p>
                                    </div>

                                    {c.tags.length > 0 &&
                                    <ul className="subnav-tag">
                                        {c.tags.map(t => (
                                            <li key={t.id} onClick={() => filterBySubTag(t)}>
                                                <p style={{backgroundColor: t.color}}
                                                   className={"category tags"}> {t.name}</p>
                                            </li>
                                        ))}
                                    </ul>
                                    }
                                </li>
                            )
                        )}
                    </Ul>
                )
            }
        }
    }

    return (
        <ContainerTags>
            <TagList>
                {displayTags()}
            </TagList>
            <SelectedContainer>
                {categorySelected.hasOwnProperty('id') ? <p> Catégorie sélectionnée
                    : <span>{categorySelected.name} {tagSelected.hasOwnProperty('id') ? "/ " + tagSelected.name : ""}</span>
                </p> : ""}
            </SelectedContainer>
        </ContainerTags>
    )
}
const ContainerTags = styled.div`
  max-width: 70%;
`
const Ul = styled.ul`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 1rem;

  .wrapper-tags-li {
    height: 30px;
  }
`
const TagList = styled.div`
  padding: 0 1em;

  li {
    transition-duration: 0.5s;
  }

  li:hover {
    cursor: pointer;
  }


  .category {
    padding: 0.2rem 1rem;
    min-width: 100px;
    border-radius: 10px;
    cursor: pointer;
    font-size: 12px;
    color: #FAFAFA;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;

    p {
      color: var(--color-white);
    }

    &:hover {
      background-color: var(--color-purple-lighten) !important;
      color: var(--color-dark);
    }
  }

  ul {
    display: flex;
    gap: 1em;
  }


  ul li ul {
    visibility: hidden;
    opacity: 0;
    margin-top: 0.2rem;
    left: 0;
    display: none;
  }

  ul li:hover > ul,
  ul li ul:hover {
    visibility: visible;
    opacity: 1;
    display: flex;
    //margin-top: 1em;
    position: relative;
  }

  ul li ul li {
    clear: both;
    width: 100%;
  }

  .subnav-tag {
    display: flex;
    flex-direction: column;
    gap: 0.5em;
    background-color: #FAFAFA;
    padding: 0.5em;
    border-radius: 10px;
    box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.25);
    z-index: 10;
  }
`

const SelectedContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  p > span {
    font-weight: 700;
  }

`
export default SearchBarByTag;